import { render } from "./ChangeOption.vue?vue&type=template&id=2a5772d7&scoped=true"
import script from "./ChangeOption.vue?vue&type=script&lang=js"
export * from "./ChangeOption.vue?vue&type=script&lang=js"

import "./ChangeOption.vue?vue&type=style&index=0&id=2a5772d7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_13b2cfeee597e475bd48dd409a32edc8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5772d7"]])

export default __exports__